const createVideoSource = (birtrate, quality, videoType, deviceWidth, urlExtension) => ({
    birtrate,
    quality,
    videoType,
    deviceWidth,
    urlExtension,
});
// changes duplicate code should be reflected in videoPlayer component as well
export const videoSource = [
    createVideoSource('1998', 'high', 'video/mp4', 'min-device-width', '/mp4_720p'),
    createVideoSource('1910', 'high', 'video/webm', 'min-device-width', '/webm_720p'),
    createVideoSource('586', 'medium', 'video/webm', 'max-device-width', '/webm_480p'),
    createVideoSource('606', 'medium', 'video/mp4', 'min-device-width', '/mp4_480p'),
    createVideoSource('326', 'low', 'video/mp4', 'max-device-width', '/mp4_240p'),
    createVideoSource('1200', 'medium', 'video/webm; codecs="vp9"', 'min-device-width', '/vp9720p'),
    createVideoSource('2500', 'high', 'video/webm; codecs="vp9"', 'min-device-width', '/vp91080p'),
    createVideoSource('1500', 'medium', 'video/mp4; codecs="hvc1"', 'min-device-width', '/hevc720p'),
    createVideoSource('2800', 'high', 'video/mp4; codecs="hvc1"', 'min-device-width', '/hevc1080p'),
];
